import useWindowDimensions from 'hooks/useWindowDimensions';
import GroomersDropdown from 'organisms/GroomersDropdown';
import NewAppointmentButton from 'organisms/NewAppointmentButton';

export const DISPLAY_NEW_APPOINTMENT_BUTTON = true;

export default function Header() {
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  return (
    <div className="appointments-page-header flex-row justify-between">
      <h1>Appointments</h1>
      {!isMobile && (
        <div className="flex-row gap-24">
          {DISPLAY_NEW_APPOINTMENT_BUTTON && <NewAppointmentButton />}
          <GroomersDropdown />
        </div>
      )}
    </div>
  );
}
